// Copyright (c) 2016 Deere & Company

import RgaSearchResultList, {getDefaultState as getRgaSearchResultList} from '../state/rga-search-result-list';
import actions from '../../actions-list';

const getRgaResultList = (state, action) => {

    if (action.isInitialLoad) {

        return RgaSearchResultList.update(state, {
            $set: action.rgaCollection
        });

    }
    return RgaSearchResultList.update(state, {
        $push: action.rgaCollection
    });

};

export default (state = getRgaSearchResultList(), action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_SEARCH_RESULTS]: getRgaResultList
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/rga-search-result.js